export default __webpack_public_path__ + "static/media/img-coupon-84.3d19bbc7.svg";